import { render, staticRenderFns } from "./WhomBlock.vue?vue&type=template&id=7b4f8d19&"
import script from "./WhomBlock.vue?vue&type=script&lang=js&"
export * from "./WhomBlock.vue?vue&type=script&lang=js&"
import style0 from "./WhomBlock.vue?vue&type=style&index=0&id=7b4f8d19&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports